import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type TeamData = {
  id: number;
  createdAt: string;
  language: 'fr' | 'en';
  name: string;
  totalOfMembers: number;
  totalOfPendingInvitations: number;
  supervisors?: {
    id: number;
    firstName: string;
    lastName: string;
    displayName: string;
    profilePicture: string;
  }[];
  description?: string;
  organizationId: string;
  disclaimer?: string;
};

const {
  useGet: useTeam,
  useFind: useTeams,
  useUpdate: useTeamUpdate,
  useDelete: useTeamDeletion,
} = getCRUDHooks<TeamData>({
  entityName: 'team',
  sharedCacheEntities: ['userTeamList', 'currentUserTeamList'],
  getHelper: () => clientApi.getOCClient().helpers.employer.teams,
});

export { useTeam, useTeams, useTeamUpdate, useTeamDeletion };
